import PropTypes from 'prop-types';
import UnverifiedCard from '../components/unverifiedCard';

const PrivateRoute = ({
  children, user, handleSignOut,
}) => {
  const {
    isAuthenticated, isVerified, userType, notCompletedRegister,
  } = user;

  if (!isAuthenticated || !userType || notCompletedRegister) {
    const loginUrl = import.meta.env.VITE_LOGIN_DOMAIN;
    window.location.replace(loginUrl);

    return null;
  }

  if (!isVerified) {
    return (
      <UnverifiedCard handleSignOut={handleSignOut} />
    );
  }

  return children;
};

PrivateRoute.propTypes = {
  handleSignOut: PropTypes.func.isRequired,
  user: PropTypes.shape({
    isAuthenticated: PropTypes.bool,
    isVerified: PropTypes.bool,
    notCompletedRegister: PropTypes.bool,
    userType: PropTypes.oneOf(['admin', 'tutor', 'parent', 'learner']).isRequired,
  }).isRequired,
};

export default PrivateRoute;
